const MenuCollapseIcon = () => {
    return (
        <svg
            id="Group_7952"
            data-name="Group 7952"
            xmlns="http://www.w3.org/2000/svg"
            width="20.75"
            height="20.75"
            viewBox="0 0 20.75 20.75"
        >
            <g id="Group_7950" data-name="Group 7950">
                <path
                    id="Path_3386"
                    data-name="Path 3386"
                    d="M7.087,19.943H3.161A2.268,2.268,0,0,1,.893,17.674V3.139A2.268,2.268,0,0,1,3.161.87H7.087Z"
                    fill="#d6d6d6"
                />
                <path
                    id="Path_3387"
                    data-name="Path 3387"
                    d="M7.087,19.943H3.161A2.268,2.268,0,0,1,.893,17.674V3.139A2.268,2.268,0,0,1,3.161.87H7.087Z"
                    fill="none"
                    stroke="#d6d6d6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <path
                    id="Path_3388"
                    data-name="Path 3388"
                    d="M.375,2.989V17.762a2.613,2.613,0,0,0,2.614,2.613H17.761a2.613,2.613,0,0,0,2.614-2.613V2.989A2.614,2.614,0,0,0,17.761.375H2.989A2.614,2.614,0,0,0,.375,2.989Z"
                    fill="none"
                    stroke="#0c3b8d"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="0.75"
                />
                <line
                    id="Line_213"
                    data-name="Line 213"
                    y1="19.721"
                    transform="translate(7.342 0.397)"
                    fill="none"
                    stroke="#0c3b8d"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="0.75"
                />
            </g>
        </svg>
    );
};

export default MenuCollapseIcon;
